import { render, staticRenderFns } from "./PatientBill.vue?vue&type=template&id=4b185fda&"
import script from "./PatientBill.vue?vue&type=script&lang=js&"
export * from "./PatientBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports